// Mock content for Horns Industriservice — bilingual (SV / EN)
// All imagery is easily swappable: change the `image` fields below.

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1716191299980-a6e8827ba10b?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2NDF8MHwxfHNlYXJjaHwzfHxpbmR1c3RyaWFsJTIwcm9ib3R8ZW58MHx8fHwxNzg5MTYwNzc3fDA&ixlib=rb-4.1.0&q=85",
  heroAlt: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NzB8MHwxfHNlYXJjaHwyfHxmYWN0b3J5JTIwYXV0b21hdGlvbnxlbnwwfHx8fDE3ODkxNjA3Nzd8MA&ixlib=rb-4.1.0&q=85",
  cnc: "https://images.unsplash.com/photo-1740209475472-aa7d280f7452?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwxfHxwcmVjaXNpb24lMjBtYWNoaW5pbmd8ZW58MHx8fHwxNzg5MTYwNzc3fDA&ixlib=rb-4.1.0&q=85",
  lathe: "https://images.unsplash.com/photo-1666634157070-6fd830fb5672?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjAzMjh8MHwxfHNlYXJjaHwyfHxwcmVjaXNpb24lMjBtYWNoaW5pbmd8ZW58MHx8fHwxNzg5MTYwNzc3fDA&ixlib=rb-4.1.0&q=85",
  gripper: "https://images.unsplash.com/photo-1784821856280-401b76b03266?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA2MTJ8MHwxfHNlYXJjaHw0fHxyb2JvdCUyMGdyaXBwZXJ8ZW58MHx8fHwxNzg5MTYwODUyfDA&ixlib=rb-4.1.0&q=85",
  factory: "https://images.unsplash.com/photo-1647427060118-4911c9821b82?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHwzfHxmYWN0b3J5JTIwbWFjaGluZXJ5fGVufDB8fHx8MTc4OTE2MDgxOXww&ixlib=rb-4.1.0&q=85",
  measure: "https://images.unsplash.com/photo-1585366958403-bacb4c36a1a9?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwzfHxwcmVjaXNpb24lMjBtZWFzdXJlbWVudHxlbnwwfHx8fDE3ODkxNjA4MTN8MA&ixlib=rb-4.1.0&q=85",
  caliper: "https://images.unsplash.com/photo-1758873263563-5ba4aa330799?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NTYxOTJ8MHwxfHNlYXJjaHwyfHxwcmVjaXNpb24lMjBtZWFzdXJlbWVudHxlbnwwfHx8fDE3ODkxNjA4MTN8MA&ixlib=rb-4.1.0&q=85",
  workshop: "https://images.unsplash.com/photo-1581092160607-ee22621dd758?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NDQ2MzR8MHwxfHNlYXJjaHwyfHxlbmdpbmVlcmluZyUyMHdvcmtzaG9wfGVufDB8fHx8MTc4OTE2MDg1Mnww&ixlib=rb-4.1.0&q=85",
  defense: "https://images.unsplash.com/photo-1548683726-203119be6a39?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2ODh8MHwxfHNlYXJjaHw0fHxtYWNoaW5lZCUyMG1ldGFsfGVufDB8fHx8MTc4OTE2MzU5Mnww&ixlib=rb-4.1.0&q=85",
  defenseAlt: "https://images.unsplash.com/photo-1769147339214-076740872485?crop=entropy&cs=srgb&fm=jpg&ixid=M3w4NjA1NTZ8MHwxfHNlYXJjaHw0fHxwcmVjaXNpb24lMjBlbmdpbmVlcmluZ3xlbnwwfHx8fDE3ODkxNjM1OTJ8MA&ixlib=rb-4.1.0&q=85",
};

// Partner names (rendered as elegant text lockups)
export const PARTNERS = [
  "Husqvarna", "Atlas Copco", "Ankarsrum", "Ljunghäll", "Titan X",
  "Ages", "Gnotec", "Rimaster", "Åbro", "Proton Group",
  "Mönsterås Metall", "HSF Group", "Stöeryd", "IAC", "Ekenäs",
];

export const CONTENT = {
  en: {
    nav: {
      collections: "Products",
      about: "The Company",
      partners: "Partners",
      contact: "Contact",
      defense: "Defense",
      policy: "Policies",
    },
    cta: { learnMore: "Learn More", discover: "Discover", contactUs: "Contact Us", all: "All Products" },
    hero: {
      overline: "Sweden's leading supplier of automation equipment",
      title: "Engineered\nprecision.",
      subtitle:
        "From concept to finished product — Horns Industriservice designs and manufactures advanced production equipment for the manufacturing industry.",
      scroll: "Scroll to explore",
    },
    intro: {
      overline: "Since 1985",
      title: "High competence for effective production solutions.",
      body:
        "We provide knowledge support and the development and optimisation of production processes. Tooling, presses, fixtures and grippers are all part of our offering — engineered with uncompromising precision and genuine Swedish craftsmanship.",
    },
    collectionsSection: {
      overline: "Our Capabilities",
      title: "Six disciplines. One standard of excellence.",
    },
    featured: {
      overline: "Signature Solution",
      title: "Automation, refined.",
      body:
        "Grippers, feeders and full robot integration — engineered as a single, seamless system. We build the automation cells that keep the finest manufacturers moving, day and night.",
    },
    defense: {
      overline: "New Division",
      title: "Engineered for Swedish defense.",
      body:
        "Horns Industriservice now manufactures precision components for the Swedish defense industry. With decades of production engineering behind us, we deliver to the highest standards of quality, traceability and security — in support of Sweden's total defence.",
      cta: "Learn more",
    },
    heritage: {
      overline: "The Company",
      title: "A workshop built on trust.",
      body:
        "The story of Horns Industriservice is one of Swedish craftsmanship. From our earliest days we set out to stand at the forefront of production engineering — delivering stable, functional solutions tailored to each customer's specific needs.",
      stats: [
        { value: "40+", label: "Years of experience" },
        { value: "6", label: "Core disciplines" },
        { value: "100%", label: "Custom engineered" },
      ],
    },
    partners: { overline: "Trusted By", title: "The manufacturers who trust our engineering." },
    contact: {
      overline: "Get in touch",
      title: "Let's build your next production solution.",
      body: "Tell us about your process. From sketch to finished production, we are ready.",
      fields: { name: "Name", email: "Email", company: "Company", message: "How can we help?", send: "Send Enquiry" },
      success: "Thank you. We'll be in touch shortly.",
      email: "info@horns.se",
      phone: "",
      address: "Horns Industriservice AB\nSverige",
    },
    footer: { rights: "All rights reserved.", tagline: "Automation solutions for the manufacturing industry." },
    policies: {
      quality: { label: "Quality Policy", badge: "ISO 9001", badgeSub: "Quality Management System", badgeImage: "/iso-9001.png", overline: "Quality Policy", heading: "Quality guides everything we do", intro: "Horns Industriservice AB designs and manufactures advanced components, production tooling and automation equipment for demanding production environments.", sections: [{ title: "Quality means that we will", body: "", points: ["understand the customer's needs and deliver the right quality", "work in a structured and preventive way", "ensure quality and traceability throughout the process", "continuously improve"] }], pdfUrl: "/horns-iso-certifikat.pdf", pdfLabel: "Download ISO certificate (PDF)" },
      environment: { label: "Environmental Policy", badge: "ISO 14001", badgeSub: "Environmental Management System", badgeImage: "/iso-14001.png", overline: "Environmental Policy", heading: "The environment – our shared responsibility", intro: "We take responsibility to understand, limit and continuously reduce the environmental impact of our operations.", sections: [{ title: "How we reduce our environmental impact", body: "", points: ["Use resources efficiently", "Prevent waste and promote recycling", "Comply with environmental legislation", "Continuously improve"] }], pdfUrl: "/horns-iso-certifikat.pdf", pdfLabel: "Download ISO certificate (PDF)" },
    },
  },
  sv: {
    nav: {
      collections: "Produkter",
      about: "Företaget",
      partners: "Partners",
      contact: "Kontakt",
      defense: "Försvar",
      policy: "Policyer",
    },
    cta: { learnMore: "Läs mer", discover: "Upptäck", contactUs: "Kontakta oss", all: "Alla produkter" },
    hero: {
      overline: "Sveriges ledande leverantör av automationsutrustning",
      title: "Konstruerad\nprecision.",
      subtitle:
        "Från idé till färdig produkt — Horns Industriservice konstruerar och tillverkar avancerad produktionsutrustning för tillverkningsindustrin.",
      scroll: "Scrolla för att utforska",
    },
    intro: {
      overline: "Sedan 1985",
      title: "Hög kompetens för effektiva produktionslösningar.",
      body:
        "Vi erbjuder kunskapsstöd samt framtagning och optimering av produktionsprocesser. Verktyg, pressar, fixturer och gripdon är alla en del av vårt erbjudande — konstruerade med kompromisslös precision och gediget svenskt hantverk.",
    },
    collectionsSection: {
      overline: "Våra förmågor",
      title: "Sex discipliner. En standard av excellens.",
    },
    featured: {
      overline: "Signaturlösning",
      title: "Automation, förfinad.",
      body:
        "Gripdon, matare och komplett robotintegration — konstruerade som ett enda, sömlöst system. Vi bygger automationscellerna som håller de finaste tillverkarna i rörelse, dag och natt.",
    },
    defense: {
      overline: "Ny gren",
      title: "Konstruerad för svenskt försvar.",
      body:
        "Horns Industriservice tillverkar nu precisionskomponenter till den svenska försvarsindustrin. Med decennier av produktionsteknik i ryggen levererar vi enligt högsta krav på kvalitet, spårbarhet och säkerhet — till stöd för Sveriges totalförsvar.",
      cta: "Läs mer",
    },
    heritage: {
      overline: "Företaget",
      title: "En verkstad byggd på förtroende.",
      body:
        "Historien om Horns Industriservice är en historia om svenskt hantverk. Från första början strävade vi efter att stå i framkant inom produktionsteknik — och leverera stabila, funktionella lösningar anpassade efter varje kunds specifika behov.",
      stats: [
        { value: "40+", label: "Års erfarenhet" },
        { value: "6", label: "Kärndiscipliner" },
        { value: "100%", label: "Kundanpassat" },
      ],
    },
    partners: { overline: "Anlitade av", title: "Tillverkarna som litar på vår ingenjörskonst." },
    contact: {
      overline: "Hör av dig",
      title: "Låt oss bygga din nästa produktionslösning.",
      body: "Berätta om din process. Från skiss till färdig produktion, vi är redo.",
      fields: { name: "Namn", email: "E-post", company: "Företag", message: "Hur kan vi hjälpa till?", send: "Skicka förfrågan" },
      success: "Tack. Vi hör av oss inom kort.",
      email: "info@horns.se",
      phone: "",
      address: "Horns Industriservice AB\nSverige",
    },
    footer: { rights: "Alla rättigheter förbehållna.", tagline: "Automationslösningar för tillverkningsindustrin." },
    policies: {
      quality: { label: "Kvalitetspolicy", badge: "ISO 9001", badgeSub: "Kvalitetsledningssystem", badgeImage: "/iso-9001.png", overline: "Kvalitetspolicy", heading: "Kvalitet styr vår verksamhet", intro: "Horns Industriservice AB konstruerar och tillverkar avancerade komponenter, produktionsverktyg och automationsutrustning för krävande produktionsmiljöer.", sections: [{ title: "Kvalitet innebär att vi ska", body: "", points: ["förstå kundens behov och leverera rätt kvalitet", "arbeta strukturerat och förebyggande", "säkerställa kvalitet och spårbarhet genom hela processen", "ständigt förbättra"] }], pdfUrl: "/horns-iso-certifikat.pdf", pdfLabel: "Ladda ner ISO-certifikat (PDF)" },
      environment: { label: "Miljöpolicy", badge: "ISO 14001", badgeSub: "Miljöledningssystem", badgeImage: "/iso-14001.png", overline: "Miljöpolicy", heading: "Miljön – vårt gemensamma ansvar", intro: "Vi tar ansvar för att förstå, begränsa och kontinuerligt minska vår verksamhets miljöpåverkan.", sections: [{ title: "Så minskar vi vår miljöpåverkan", body: "", points: ["Använda resurser effektivt", "Förebygga avfall och främja återvinning", "Följa miljölagstiftning", "Ständigt förbättra"] }], pdfUrl: "/horns-iso-certifikat.pdf", pdfLabel: "Ladda ner ISO-certifikat (PDF)" },
    },
  },
};

// Six product categories (from the client's production-cycle diagram)
export const COLLECTIONS = [
  {
    id: "production-tools",
    image: IMAGES.cnc,
    number: "01",
    en: {
      name: "Production Tools",
      short: "Tooling for machining",
      desc: "Advanced production tools for the machining industry — special tooling for turning, milling and cutting operations.",
      points: ["Follow-on & press tools", "Turning & milling tooling", "Deburring & finishing"],
    },
    sv: {
      name: "Produktionsverktyg",
      short: "Verktyg för bearbetning",
      desc: "Avancerade produktionsverktyg för bearbetningsindustrin — specialverktyg för svarvning, fräsning och skärande bearbetning.",
      points: ["Följd- & pressverktyg", "Svarv- & fräsverktyg", "Skäggverktyg & efterbearbetning"],
    },
  },
  {
    id: "robots-accessories",
    image: IMAGES.gripper,
    number: "02",
    en: {
      name: "Robots & Accessories",
      short: "Grippers & integration",
      desc: "Grippers, feeders and complete integration with robots and automation — conveyors and custom transport solutions.",
      points: ["Custom grippers", "Robot integration", "Conveyors & feeders"],
    },
    sv: {
      name: "Robotar & Tillbehör",
      short: "Gripdon & integration",
      desc: "Gripdon, matare och komplett integration med robotar och automation — transportörer och kundanpassade transportlösningar.",
      points: ["Kundanpassade gripdon", "Robotintegration", "Transportörer & matare"],
    },
  },
  {
    id: "hydraulic-solutions",
    image: IMAGES.factory,
    number: "03",
    en: {
      name: "Hydraulic Solutions",
      short: "Presses & power",
      desc: "Hydraulic presses and solutions built for reliability, precision and raw power — the backbone of demanding production.",
      points: ["Hydraulic presses", "Custom hydraulics", "Reliability engineered"],
    },
    sv: {
      name: "Hydraullösningar",
      short: "Pressar & kraft",
      desc: "Hydraulpressar och lösningar byggda för tillförlitlighet, precision och ren kraft — ryggraden i krävande produktion.",
      points: ["Hydraulpressar", "Kundanpassad hydraulik", "Konstruerad tillförlitlighet"],
    },
  },
  {
    id: "verification",
    image: IMAGES.measure,
    number: "04",
    en: {
      name: "Verification",
      short: "Control & measurement",
      desc: "Control and measurement equipment ensuring precision and quality at every stage of the production process.",
      points: ["Measurement fixtures", "Quality control", "Precision verification"],
    },
    sv: {
      name: "Verifiering",
      short: "Kontroll & mätning",
      desc: "Kontroll- och mätutrustning som säkerställer precision och kvalitet i varje steg av produktionsprocessen.",
      points: ["Mätfixturer", "Kvalitetskontroll", "Precisionsverifiering"],
    },
  },
  {
    id: "machines",
    image: IMAGES.caliper,
    number: "05",
    en: {
      name: "Machines & Fixtures",
      short: "Fixtures & equipment",
      desc: "Machining fixtures, press tools and follow-on tools — advanced, purpose-built production equipment.",
      points: ["Machining fixtures", "Press tooling", "Production equipment"],
    },
    sv: {
      name: "Maskiner & Fixturer",
      short: "Fixturer & utrustning",
      desc: "Bearbetningsfixturer, pressverktyg och följdverktyg — avancerad, ändamålsbyggd produktionsutrustning.",
      points: ["Bearbetningsfixturer", "Pressverktyg", "Produktionsutrustning"],
    },
  },
  {
    id: "defense-components",
    image: IMAGES.defenseAlt,
    number: "06",
    en: {
      name: "Defense Components",
      short: "Swedish defense manufacturing",
      desc: "Precision-manufactured components for the Swedish defense industry — engineered to the most demanding standards of quality, traceability and reliability.",
      points: ["Precision components", "Full traceability", "Swedish defense industry"],
    },
    sv: {
      name: "Försvarskomponenter",
      short: "Tillverkning för svenskt försvar",
      desc: "Precisionstillverkade komponenter till den svenska försvarsindustrin — konstruerade enligt de mest krävande kraven på kvalitet, spårbarhet och tillförlitlighet.",
      points: ["Precisionskomponenter", "Full spårbarhet", "Svensk försvarsindustri"],
    },
  },
];

const _GALLERY = {
  "production-tools": [
    { image: IMAGES.cnc, sv: { title: "5-axlig fräsning", desc: "Komplexa geometrier i härdat verktygsstål, toleranser ±0,01 mm." }, en: { title: "5-axis milling", desc: "Complex geometries in hardened tool steel, tolerances ±0.01 mm." } },
    { image: IMAGES.lathe, sv: { title: "Precisionssvarvning", desc: "Serietillverkade komponenter med hög repeterbarhet." }, en: { title: "Precision turning", desc: "Series-produced components with high repeatability." } },
  ],
  "robots-accessories": [
    { image: IMAGES.gripper, sv: { title: "Kundanpassat gripdon", desc: "Servostyrt grepp för säker hantering av detaljer." }, en: { title: "Custom gripper", desc: "Servo-controlled grip for safe part handling." } },
    { image: IMAGES.heroAlt, sv: { title: "Robotcell", desc: "Komplett integration med säkerhetszoner och transportörer." }, en: { title: "Robot cell", desc: "Full integration with safety zones and conveyors." } },
  ],
  "hydraulic-solutions": [
    { image: IMAGES.factory, sv: { title: "Hydraulpress", desc: "Presskraft upp till 200 ton med programmerbart förlopp." }, en: { title: "Hydraulic press", desc: "Press force up to 200 tonnes with a programmable cycle." } },
    { image: IMAGES.hero, sv: { title: "Automationslinje", desc: "Integrerade pressar i ett helautomatiserat flöde." }, en: { title: "Automation line", desc: "Integrated presses in a fully automated flow." } },
  ],
  "verification": [
    { image: IMAGES.measure, sv: { title: "Koordinatmätning", desc: "CMM-mätning för verifiering mot ritningskrav." }, en: { title: "Coordinate measurement", desc: "CMM measurement for verification against drawing requirements." } },
    { image: IMAGES.caliper, sv: { title: "Kvalitetskontroll", desc: "Manuell och digital mätning i produktion." }, en: { title: "Quality control", desc: "Manual and digital measurement in production." } },
  ],
  "machines": [
    { image: IMAGES.caliper, sv: { title: "Bearbetningsfixtur", desc: "Repeterbar uppspänning för stabil bearbetning." }, en: { title: "Machining fixture", desc: "Repeatable clamping for stable machining." } },
    { image: IMAGES.workshop, sv: { title: "Verkstad", desc: "Konstruktion och tillverkning under samma tak." }, en: { title: "Workshop", desc: "Design and manufacturing under one roof." } },
  ],
  "defense-components": [
    { image: IMAGES.defense, sv: { title: "Precisionskomponent", desc: "Tillverkad med full spårbarhet enligt försvarskrav." }, en: { title: "Precision component", desc: "Manufactured with full traceability to defense standards." } },
    { image: IMAGES.defenseAlt, sv: { title: "Detaljbearbetning", desc: "Höga krav på ytfinish och måttnoggrannhet." }, en: { title: "Detail machining", desc: "High demands on surface finish and dimensional accuracy." } },
  ],
};

COLLECTIONS.forEach((c) => { c.gallery = _GALLERY[c.id] || []; });
